const currentUrl = window.location.href;

export const config = currentUrl.includes("local") ? {
    appId: "76bda789-19fb-4004-badd-16298f56a7d3",
    redirectUri: "http://localhost:3000",
    scopes: [
        'user.read'
    ],
    authority: "https://login.microsoftonline.com/afficiency.onmicrosoft.com" 

} : currentUrl.includes("test") ?
{
    appId: "91db2499-bfc9-4e27-8b7a-ae9f4fe8bf71",
    redirectUri: "https://agentportal-test.afficiency.com/",
    scopes: [
        'user.read'
    ],
    authority: "https://login.microsoftonline.com/afficiency.onmicrosoft.com" 
} :
{
    appId: "618dcb3d-23c5-4bf1-b780-c4e226ebfbc4",
    redirectUri: "https://agentportal.afficiency.com/",
    scopes: [
        'user.read'
    ],
    authority: "https://login.microsoftonline.com/afficiency.onmicrosoft.com" 
}